import React, { useState, useEffect } from 'react'
import ImageWithBasePath from '../../core/img/imagewithbasebath'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ChevronUp, Filter, Sliders, Zap, Save, X, Plus } from 'react-feather';
import { setToogleHeader } from '../../core/redux/action';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { RotateCcw } from 'feather-icons-react/build/IconComponents';
import { DatePicker } from 'antd';
import PermissionServices from '../../services/Permission';
import RoleServices from '../../services/Role';
import { toast } from 'react-toastify';
import AddPermission from '../../core/modals/usermanagement/addpermission';

const Permissions = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);
    const [isFilterVisible, setIsFilterVisible] = useState(false);
    const [permissions, setPermissions] = useState([]);
    const [roles, setRoles] = useState([]);
    const [selectedRole, setSelectedRole] = useState(null);
    const [rolePermissions, setRolePermissions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    const toggleFilterVisibility = () => {
        setIsFilterVisible((prevVisibility) => !prevVisibility);
    };
    const [selectedDate, setSelectedDate] = useState(new Date());
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    // Load permissions and roles on component mount
    useEffect(() => {
        loadPermissions();
        loadRoles();
    }, []);

    // Check for roleId in URL params
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const roleId = urlParams.get('roleId');
        if (roleId && roles.length > 0) {
            const role = roles.find(r => r.id == roleId);
            if (role) {
                handleRoleChange({ value: role.id, label: role.name });
            }
        }
    }, [roles]);

    const loadPermissions = async () => {
        try {
            const response = await PermissionServices.getPermissions();
            setPermissions(response.data || []);
        } catch (error) {
            toast.error('Failed to load permissions');
        }
    };

    const loadRoles = async () => {
        try {
            const response = await RoleServices.getRoles();
            setRoles(response.data || []);
        } catch (error) {
            toast.error('Failed to load roles');
        }
    };

    const handleRoleChange = async (selectedOption) => {
        setSelectedRole(selectedOption);
        if (selectedOption) {
            setLoading(true);
            try {
                const response = await RoleServices.getRolePermissions(selectedOption.value);
                const rolePerms = response.data?.permissions || [];
                console.log('Role permissions loaded:', rolePerms); // Debug log
                setRolePermissions(rolePerms.map(p => p.id));
            } catch (error) {
                console.error('Failed to load role permissions:', error); // Debug log
                toast.error('Failed to load role permissions');
                setRolePermissions([]);
            } finally {
                setLoading(false);
            }
        } else {
            setRolePermissions([]);
        }
    };

    const handlePermissionChange = (permissionId, action) => {
        setRolePermissions(prev => {
            if (action === 'add') {
                return [...prev, permissionId];
            } else {
                return prev.filter(id => id !== permissionId);
            }
        });
    };

    const handleSavePermissions = async () => {
        if (!selectedRole) {
            toast.error('Please select a role first');
            return;
        }

        setSaving(true);
        try {
            await RoleServices.assignPermissionsToRole(selectedRole.value, rolePermissions);
            toast.success('Permissions updated successfully');
        } catch (error) {
            toast.error('Failed to update permissions');
        } finally {
            setSaving(false);
        }
    };

    const roleOptions = roles.map(role => ({
        value: role.id,
        label: role.name
    }));

    // Group permissions by module
    const groupedPermissions = permissions.reduce((acc, permission) => {
        const lastIndex = permission.name.lastIndexOf('_');
        const module = (permission.name.substr(0, lastIndex)).replace(/_/g, " ");
        if (!acc[module]) acc[module] = [];
        acc[module].push(permission);
        return acc;
    }, {});

    const handleSelectAll = (checked) => {
        Object.entries(groupedPermissions).forEach(([module, modulePermissions]) => {
            const createPerm = modulePermissions.find(p => p.name.includes('_create'));
            const readPerm = modulePermissions.find(p => p.name.includes('_read'));
            const updatePerm = modulePermissions.find(p => p.name.includes('_update'));
            const deletePerm = modulePermissions.find(p => p.name.includes('_delete'));

            const action = checked ? 'add' : 'remove';
            if (createPerm) handlePermissionChange(createPerm.id, action);
            if (readPerm) handlePermissionChange(readPerm.id, action);
            if (updatePerm) handlePermissionChange(updatePerm.id, action);
            if (deletePerm) handlePermissionChange(deletePerm.id, action);
        });
    };

    const allSelected = Object.entries(groupedPermissions).every(([module, modulePermissions]) => {
        const createPerm = modulePermissions.find(p => p.name.includes('_create'));
        const readPerm = modulePermissions.find(p => p.name.includes('_read'));
        const updatePerm = modulePermissions.find(p => p.name.includes('_update'));
        const deletePerm = modulePermissions.find(p => p.name.includes('_delete'));

        return createPerm && readPerm && updatePerm && deletePerm &&
               rolePermissions.includes(createPerm.id) &&
               rolePermissions.includes(readPerm.id) &&
               rolePermissions.includes(updatePerm.id) &&
               rolePermissions.includes(deletePerm.id);
    });

    const someSelected = Object.entries(groupedPermissions).some(([module, modulePermissions]) => {
        const createPerm = modulePermissions.find(p => p.name.includes('_create'));
        const readPerm = modulePermissions.find(p => p.name.includes('_read'));
        const updatePerm = modulePermissions.find(p => p.name.includes('_update'));
        const deletePerm = modulePermissions.find(p => p.name.includes('_delete'));

        return (createPerm && rolePermissions.includes(createPerm.id)) ||
               (readPerm && rolePermissions.includes(readPerm.id)) ||
               (updatePerm && rolePermissions.includes(updatePerm.id)) ||
               (deletePerm && rolePermissions.includes(deletePerm.id));
    });


    const oldandlatestvalue = [
        { value: 'date', label: 'Sort by Date' },
        { value: 'newest', label: 'Newest' },
        { value: 'oldest', label: 'Oldest' },
    ];
    const renderTooltip = (props) => (
        <Tooltip id="pdf-tooltip" {...props}>
            Pdf
        </Tooltip>
    );
    const renderExcelTooltip = (props) => (
        <Tooltip id="excel-tooltip" {...props}>
            Excel
        </Tooltip>
    );
    const renderPrinterTooltip = (props) => (
        <Tooltip id="printer-tooltip" {...props}>
            Printer
        </Tooltip>
    );
    const renderRefreshTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Refresh
        </Tooltip>
    );
    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    )
    return (
        <div className="main-wrapper">
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Permission</h4>
                                <h6>Manage your permissions</h6>
                            </div>
                        </div>
                        <div className="page-btn">
                            <button
                                type="button"
                                className="btn btn-added"
                                data-bs-toggle="modal"
                                data-bs-target="#add-permission"
                            >
                                <Plus className="me-2" />
                                Add New Permission
                            </button>
                        </div>
                        {/* <ul className="table-top-head">
                            <li>
                                <OverlayTrigger placement="top" overlay={renderTooltip}>
                                    <Link>
                                        <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <i data-feather="printer" className="feather-printer" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <RotateCcw />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul> */}
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            {/* <div className="table-top">
                                <div className="search-set">
                                    <div className="search-input">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="form-control form-control-sm formsearch"
                                        />
                                        <Link to className="btn btn-searchset">
                                            <i data-feather="search" className="feather-search" />
                                        </Link>
                                    </div>
                                </div>
                                <div className="search-path">
                                    <Link className={`btn btn-filter ${isFilterVisible ? "setclose" : ""}`} id="filter_search">
                                        <Filter
                                            className="filter-icon"
                                            onClick={toggleFilterVisibility}
                                        />
                                        <span onClick={toggleFilterVisibility}>
                                            <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
                                        </span>
                                    </Link>
                                </div>
                                <div className="form-sort">
                                    <Sliders className="info-img" />
                                    <Select className="img-select"
                                        classNamePrefix="react-select"
                                        options={oldandlatestvalue}
                                        placeholder="Newest"
                                    />
                                </div>
                            </div> */}
                            {/* /Filter */}
                            {/* <div
                                className={`card${isFilterVisible ? ' visible' : ''}`}
                                id="filter_inputs"
                                style={{ display: isFilterVisible ? 'block' : 'none' }}
                            >
                                <div className="card-body pb-0">
                                    <div className="row">
                                        <div className="col-lg-3 col-sm-6 col-12">
                                            <div className="input-blocks">
                                                <Zap className="info-img" />

                                                <Select
                                                    classNamePrefix="react-select"
                                                    options={roleOptions}
                                                    value={selectedRole}
                                                    onChange={handleRoleChange}
                                                    placeholder="Choose Role"
                                                    isLoading={loading}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-sm-6 col-12">
                                            <div className="input-blocks">
                                                <div className="input-groupicon">
                                                    <DatePicker
                                                        selected={selectedDate}
                                                        onChange={handleDateChange}
                                                        type="date"
                                                        className="filterdatepicker"
                                                        dateFormat="MM-DD-YYYY"
                                                        placeholder='Choose Date'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                                            <div className="input-blocks">
                                                <a className="btn btn-filters ms-auto">
                                                    {" "}
                                                    <i data-feather="search" className="feather-search" />{" "}
                                                    Search{" "}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* /Filter */}
                            <div className="table-responsive">
                                {permissions.length > 0 ? (
                                    <>
                                        <div className="mb-3">
                                            <Select
                                                classNamePrefix="react-select"
                                                options={roleOptions}
                                                value={selectedRole}
                                                onChange={handleRoleChange}
                                                placeholder="Choose Role"
                                                isLoading={loading}
                                            />
                                        </div>
                                        {selectedRole ? (
                                        <>
                                            <table className="table datanew">
                                                <thead>
                                                    <tr>
                                                        <th className="no-sort">
                                                            <label className="checkboxs">
                                                                <input
                                                                    type="checkbox"
                                                                    id="select-all"
                                                                    checked={allSelected}
                                                                    ref={(el) => {
                                                                        if (el) el.indeterminate = !allSelected && someSelected;
                                                                    }}
                                                                    onChange={(e) => {
                                                                        if (allSelected) {
                                                                            handleSelectAll(false);
                                                                        } else {
                                                                            handleSelectAll(true);
                                                                        }
                                                                    }}
                                                                />
                                                                <span className="checkmarks" />
                                                            </label>
                                                        </th>
                                                        <th>Modules</th>
                                                        <th>Create</th>
                                                        <th>Edit</th>
                                                        <th>View</th>
                                                        <th>Delete</th>
                                                        <th className="no-sort">Allow all</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Object.entries(groupedPermissions).map(([module, modulePermissions]) => {
                                                        const createPerm = modulePermissions.find(p => p.name.includes('_create'));
                                                        const readPerm = modulePermissions.find(p => p.name.includes('_read'));
                                                        const updatePerm = modulePermissions.find(p => p.name.includes('_update'));
                                                        const deletePerm = modulePermissions.find(p => p.name.includes('_delete'));

                                                        const hasAll = createPerm && readPerm && updatePerm && deletePerm &&
                                                                      rolePermissions.includes(createPerm.id) &&
                                                                      rolePermissions.includes(readPerm.id) &&
                                                                      rolePermissions.includes(updatePerm.id) &&
                                                                      rolePermissions.includes(deletePerm.id);

                                                        return (
                                                            <tr key={module}>
                                                                <td>
                                                                    <label className="checkboxs">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={hasAll}
                                                                            onChange={(e) => {
                                                                                const action = e.target.checked ? 'add' : 'remove';
                                                                                if (createPerm) handlePermissionChange(createPerm.id, action);
                                                                                if (readPerm) handlePermissionChange(readPerm.id, action);
                                                                                if (updatePerm) handlePermissionChange(updatePerm.id, action);
                                                                                if (deletePerm) handlePermissionChange(deletePerm.id, action);
                                                                            }}
                                                                        />
                                                                        <span className="checkmarks" />
                                                                    </label>
                                                                </td>
                                                                <td className="text-capitalize">{module}</td>
                                                                <td>
                                                                    {createPerm && (
                                                                        <label className="checkboxs">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={rolePermissions.includes(createPerm.id)}
                                                                                onChange={(e) => handlePermissionChange(createPerm.id, e.target.checked ? 'add' : 'remove')}
                                                                            />
                                                                            <span className="checkmarks" />
                                                                        </label>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {updatePerm && (
                                                                        <label className="checkboxs">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={rolePermissions.includes(updatePerm.id)}
                                                                                onChange={(e) => handlePermissionChange(updatePerm.id, e.target.checked ? 'add' : 'remove')}
                                                                            />
                                                                            <span className="checkmarks" />
                                                                        </label>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {readPerm && (
                                                                        <label className="checkboxs">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={rolePermissions.includes(readPerm.id)}
                                                                                onChange={(e) => handlePermissionChange(readPerm.id, e.target.checked ? 'add' : 'remove')}
                                                                            />
                                                                            <span className="checkmarks" />
                                                                        </label>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {deletePerm && (
                                                                        <label className="checkboxs">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={rolePermissions.includes(deletePerm.id)}
                                                                                onChange={(e) => handlePermissionChange(deletePerm.id, e.target.checked ? 'add' : 'remove')}
                                                                            />
                                                                            <span className="checkmarks" />
                                                                        </label>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    <label className="checkboxs">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={hasAll}
                                                                            onChange={(e) => {
                                                                                const action = e.target.checked ? 'add' : 'remove';
                                                                                if (createPerm) handlePermissionChange(createPerm.id, action);
                                                                                if (readPerm) handlePermissionChange(readPerm.id, action);
                                                                                if (updatePerm) handlePermissionChange(updatePerm.id, action);
                                                                                if (deletePerm) handlePermissionChange(deletePerm.id, action);
                                                                            }}
                                                                        />
                                                                        <span className="checkmarks" />
                                                                    </label>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                            <div className="mt-3 d-flex justify-content-end">
                                                <button
                                                    className="btn btn-primary me-2"
                                                    onClick={handleSavePermissions}
                                                    disabled={saving}
                                                >
                                                    <Save className="me-2" size={16} />
                                                    {saving ? 'Saving...' : 'Save Permissions'}
                                                </button>
                                                <button
                                                    className="btn btn-secondary"
                                                    onClick={() => {
                                                        setSelectedRole(null);
                                                        setRolePermissions([]);
                                                    }}
                                                >
                                                    <X className="me-2" size={16} />
                                                    Cancel
                                                </button>
                                            </div>
                                        </>
                                        ) : (
                                            <div className="text-center py-5">
                                                <div className="mb-3">
                                                    <i className="fas fa-shield-alt fa-3x text-muted"></i>
                                                </div>
                                                <h5 className="text-muted">Select a Role to Manage Permissions</h5>
                                                <p className="text-muted">Please select a role from the dropdown above to view and manage its permissions.</p>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <div className="text-center py-5">
                                        <div className="mb-3">
                                            <i className="fas fa-spinner fa-spin fa-3x text-muted"></i>
                                        </div>
                                        <h5 className="text-muted">Loading Permissions...</h5>
                                        <p className="text-muted">Please wait while we load the permissions data.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>
            <AddPermission />
        </div>
    )
}

export default Permissions
